import * as React from "react";

import LoaderGif from "../controls/LoaderGif";

import { DataService } from "../../services/dataService";
import { popup } from "../../services/notifyService";
import { IAjaxResponse, ITeamInfo } from "../../models/interfaces";

export interface IRetroactivePickModalProps {
    authenticationToken: string;
    leagueMemberId: number;
    memberTeamName: string;
    weekNumber: number;
    teams: Array<ITeamInfo>;
    onClose: (saved: boolean) => void;
}

const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1050,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};

const dialogStyle: React.CSSProperties = {
    backgroundColor: '#FFF',
    borderRadius: '4px',
    boxShadow: '0 3px 9px rgba(0, 0, 0, 0.5)',
    padding: '15px 20px 20px 20px',
    width: '90%',
    maxWidth: '400px'
};

const RetroactivePickModal = (props: IRetroactivePickModalProps) => {

    const [selectedTeamId, setSelectedTeamId] = React.useState<number>(0);
    const [saving, setSaving] = React.useState<boolean>(false);

    const okClicked = (): void => {
        if (selectedTeamId === 0) {
            return;
        }
        setSaving(true);
        DataService.retroactivePick(
            props.authenticationToken,
            props.leagueMemberId,
            selectedTeamId).then((response: IAjaxResponse) => {
                if (response.success) {
                    popup('Retroactive Pick Made', 'Retroactive pick made successfully.', "info");
                    props.onClose(true);
                } else {
                    popup('Error Making Retroactive Pick', `Unable to make retroactive pick. ${response.message}`, "error");
                    setSaving(false);
                }
            });
    }

    return (
        <div style={overlayStyle}>
            <div style={dialogStyle}>
                <h4>Retroactive Week {props.weekNumber} Pick</h4>
                <p>{props.memberTeamName}</p>
                <select
                    className="form-control"
                    value={selectedTeamId}
                    onChange={e => setSelectedTeamId(parseInt(e.target.value, 10))}
                    >
                    <option value={0}>&lt;select a team&gt;</option>
                    {props.teams.map(t =>
                        <option key={t.teamId} value={t.teamId}>{t.displayName}</option>)}
                </select>
                <div style={{ marginTop: '15px', textAlign: 'right' }}>
                    <LoaderGif gif="" visible={saving} />
                    &nbsp;
                    <button
                        type="submit"
                        className="btn btn-pickem-blue button-margin"
                        disabled={saving || selectedTeamId === 0}
                        onClick={okClicked}
                        >OK</button>
                    &nbsp;
                    <button
                        type="submit"
                        className="btn btn-pickem-blue button-margin"
                        disabled={saving}
                        onClick={() => props.onClose(false)}
                        >Cancel</button>
                </div>
            </div>
        </div>
    );
}

export default RetroactivePickModal;
